export default () => ({
  errors: [],
  nbErrorsInSession: 0,
  maintenanceCode: ''
})
